import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const ConfirmActionDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmLabel = "Confirm",
  confirmColor = "primary",
  optionalAction,
  disableConfirm = false,
}) => {
  // Identical wherever it renders; only its position changes (see DialogActions).
  const cancelButton = (
    <Button variant="text" onClick={onClose}>
      Cancel
    </Button>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-action-dialog"
      PaperProps={{
        sx: (theme) => ({
          [theme.breakpoints.only("xs")]: {
            width: "100%",
            maxWidth: "100%",
            m: 2,
          },
        }),
      }}
    >
      <DialogTitle id="confirm-action-dialog" sx={{ px: 2, pt: 2, pb: 0 }}>
        {title}
      </DialogTitle>

      <DialogContent sx={{ px: 2, py: 0 }}>{message}</DialogContent>

      {/* With an optional action, the two ways of going ahead sit together on
          the right and Cancel moves to the left edge, so the choice reads as
          "one of these, or back out" rather than three peers in a row. */}
      <DialogActions
        sx={{
          p: 2,
          justifyContent: optionalAction ? "space-between" : "flex-end",
        }}
      >
        {optionalAction && cancelButton}

        <Box sx={{ display: "flex", gap: 1 }}>
          {optionalAction ? (
            <Button
              variant="outlined"
              onClick={() => {
                optionalAction.onClick();
                onClose();
              }}
            >
              {optionalAction.label}
            </Button>
          ) : (
            cancelButton
          )}
          <Button
            variant="contained"
            color={confirmColor}
            onClick={onConfirm}
            autoFocus
            disabled={disableConfirm}
          >
            {confirmLabel}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmActionDialog;
